














































































import { Component, Mixins } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import TextfieldEditor from '@/components/TextfieldEditor.vue';
import LanguagesDropDown from '@/components/DropDowns/LanguagesDropDown.vue';
import TicketHelper from '@/mixins/TicketHelper.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

@Component({
    components: {
        TextfieldEditor,
        LanguagesDropDown,
    },
})
export default class AddNewInquiry extends Mixins(TicketHelper, InputFieldMethods, NotifyMethods) {
    public newInquiryTitles: any = [];
    public newInquiryMessages: any = [];

    public newInquiryAllow: boolean = true;
    public newInquiryPriority: any = '0';
    public currentLanguage = 'en';

    constructor() {
        super();
    }

    public setTranslatableFields(languages: any) {
        languages.forEach((language: any) => {
            this.addTranslation(language);
        });
    }

    public addTranslation(addedLanguage: any) {
        const checkIfExist = this.newInquiryTitles.find((title: any) => title.lang === addedLanguage.key);

        if (typeof checkIfExist === 'undefined') {
            this.newInquiryTitles.push({ lang: addedLanguage.key, content: '' });
            this.newInquiryMessages.push({ lang: addedLanguage.key, content: '' });
        }
    }

    public removeTranslation(deletedLanguage: any) {
        this.newInquiryTitles = this.newInquiryTitles.filter((title: any) => title.lang !== deletedLanguage.key);
        this.newInquiryMessages = this.newInquiryMessages.filter((title: any) => title.lang !== deletedLanguage.key);
    }

    public setCurrentLanguage(selectedLanguage: any) {
        this.currentLanguage = selectedLanguage.key;
    }

    public addNewInquiry() {
        if (!this.newInquiryMessages.length || typeof this.newInquiryMessages.find((title: any) => title.content.trim() === '') !== 'undefined') {
            return this.notify('please_fill_message_field', 'warning');
        }

        this.$validator.validate()
            .then((valid) => {
                if (valid) {
                    this.$store.dispatch(Actions.ADD_NEW_INQUIRY, {
                        newInquiryTitles: this.newInquiryTitles,
                        newInquiryMessages: this.newInquiryMessages,
                        newInquiryAllow: this.newInquiryAllow,
                        newInquiryPriority: this.newInquiryPriority,
                        currentProject: Number(this.$store.getters['TicketAttributes/getCurrentProject']),
                        typeId: this.$store.getters['TicketAttributes/getCurrentTicketType'],
                        categoryId: this.$store.getters['TicketAttributes/getCurrentTicketCategory'],
                    });
                }
            });
    }

    public setInquiryMessage(message: any) {
        const newInquiryMessage = this.newInquiryMessages.find((newMessage: any) => newMessage.lang === this.currentLanguage);
        newInquiryMessage.content = message;
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_INQUIRY_VISIBILITY, false);
    }
}
